import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero-section">
      <div className="hero-background">
        <div className="gradient-overlay"></div>
        <div className="grid-pattern"></div>
      </div>
      <div className="container">
        <div className="hero-content-wrapper">
          <div className="hero-content">
            <h1 className="hero-title">
              Conversational Therapy for <span className="highlight">Everyone</span>
            </h1>
            <p className="hero-description">
              Hopmate makes conversational therapy services accessible in your city. 
              Speak in your language, find peace of mind.
            </p>
            <a 
              href="http://play.google.com/store/apps/details?id=com.simpleviralgames.hopmate" 
              className="cta-button"
            >
              <span>Download Now</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
          <div className="hero-images">
            <div className="image-container">
              <img 
                src="/assets/img/hero/hero-img-1.png" 
                alt="Hopmate App" 
                className="hero-img hero-img-1"
              />
              <div className="floating-card card-1">
                <div className="card-icon">💬</div>
                <div className="card-text">Anonymous</div>
              </div>
              <div className="floating-card card-2">
                <div className="card-icon">🔒</div>
                <div className="card-text">Secure</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

